(function(){
  var path = (decodeURIComponent(window.location.pathname || '') || '').toLowerCase();

  // Mapping keywords → collection URLs
  var redirects = {
    "sling-bogo": "/collections/sling-bogo",
    "nadia-sling": "/collections/nadia-sling-bag",
    "kiya-baguette": "/collections/kiya-baguette",
    "lyra-baguette": "/collections/lyra-baguette",
    "harmony-sling": "/collections/harmony-sling-bag",
    "flap-sling": "/collections/flap-sling-bags",
    "u-shaped-sling": "/collections/u-shaped-sling-bags",
    "saisha-sling": "/collections/saisha-sling-bag",
    "zoe-sling": "/collections/zoe-sling-bag",
    "aalya-baguette": "/collections/aalya-baguette",
    "shoulder-bag": "/collections/shoulder-bags",
    "regular-sling": "/collections/regular-sling-bags",
    "classic-wallet": "/collections/classic-wallets",
    "women-office-laptop": "/collections/women-office-laptop-bag",
    "aalya-baguette" :"/collections/aalya-baguette",
    "kyra" :"/collections/kyra-flap-wallet",
    "office-tote-bag" : "/collections/office-tote-bags",
    "amalia-backpack-large" : "/collections/amalia-backpack-large",
    "classic-handbag" : "/collections/regular-handbags",
    "consultant-backpack": "/collections/pro-backpack",
    "dome-daypack" : "/collections/dome-daypack",
    "office-backpack" : "/collections/office-backpack",
    "ooo-sling-bag" : "/collections/ooo-sling-bag",
    "consultant-backpack": "/collections/pro-backpack",
    "statement-backpack" : "/collections/statement-backpack",
    "womens-office-bag" : "/collections/women-office-laptop-bag",
    "womens-work-bag" :"/collections/womens-work-bag",
    "baguette": "/collections/baguette",
    "classic-utility-pouch": "/collections/classic-utility-pouch",
    "everyday-tote-bag" : "/collections/everyday-tote-bag",
    "office-backpack" : "/collections/office-backpack",
    "lunch-bag" : "/collections/lunch-bag",
    "mens-office-backpack" : "/collections/bags-for-men",
    "luna-handbag" : "/collections/luna-handbag",
    "office-essential-tote-bag": "/collections/office-essential-bag"
   
  };

  var target = "/"; // default redirect (homepage)
  for (var key in redirects) {
    if (path.includes(key)) {
      target = redirects[key];
      break;
    }
  }

  // Redirect after short delay
  setTimeout(function(){
    window.location.href = target;
  }, 800);
})();
